module.exports = __webpack_public_path__ + "img/kapitalna-firm_logo.38b6aa48.jpg";